export const translations = {
  fr: {
    nav: {
      home: "Accueil",
      services: "Services",
      offers: "Offres",
      tools: "Outils collaboratifs",
      about: "À propos",
      contact: "Contact",
      cta: "Nous contacter",
    },
    hero: {
      overline: "CLOUD COMPUTING / INFRASTRUCTURE / DEVOPS",
      title1: "Expertise en",
      titleAccent: "Cloud Computing",
      title2: "& Infrastructures IT",
      subtitle:
        "SMAKTECH accompagne les entreprises dans la conception, le déploiement et l'exploitation de leurs infrastructures informatiques — du conseil à la production.",
      ctaPrimary: "Démarrer un projet",
      ctaSecondary: "Découvrir nos services",
      stat1: "Conseil",
      stat1Label: "Architecture & Migration Cloud",
      stat2: "24/7",
      stat2Label: "Supervision & Monitoring",
      stat3: "On-Premise",
      stat3Label: "Cloud privé & Hybride",
    },
    services: {
      overline: "NOS SERVICES",
      title: "Une expertise complète, du conseil à l'exploitation.",
      subtitle:
        "Nous couvrons l'intégralité de la chaîne de valeur de votre infrastructure IT.",
      items: {
        consulting: {
          title: "Conseil & accompagnement Cloud",
          desc: "Choix de la solution la plus adaptée, conception d'architecture, migration vers le cloud, optimisation des coûts et des performances.",
          bullets: [
            "Choix de la solution cloud",
            "Architecture & conception",
            "Migration vers le cloud",
            "Cloud privé On-Premise",
            "Optimisation coûts & performances",
            "Accompagnement des équipes techniques",
          ],
        },
        supervision: {
          title: "Supervision & exploitation",
          desc: "Maintien en condition opérationnelle de vos services critiques, 24/7.",
          bullets: [
            "Supervision des infrastructures",
            "Monitoring systèmes & applications",
            "Gestion proactive des incidents",
            "Maintien en condition opérationnelle",
          ],
        },
        infra: {
          title: "Gestion des infrastructures IT",
          desc: "Trois niveaux d'accompagnement — Self-Managed, Co-Managed et Fully Managed — pour s'adapter à votre organisation.",
          bullets: [
            "Administration systèmes & réseaux",
            "Sécurité & conformité",
            "Déploiement & suivi projets",
            "Support technique",
          ],
        },
        tools: {
          title: "Outils collaboratifs",
          desc: "Nextcloud, Collabora Office, Nextcloud Talk, gestion documentaire, partage de fichiers sécurisé.",
          bullets: [
            "Nextcloud",
            "Collabora Office",
            "Nextcloud Talk",
            "GED & partage sécurisé",
          ],
        },
      },
    },
    trainings: {
      overline: "FORMATIONS",
      title: "Montez en compétence avec nos formations.",
      subtitle:
        "Nous formons vos équipes aux pratiques modernes du cloud, de l'automatisation et de l'administration système — sur site, à distance ou en blended learning.",
      formatLabel: "Format",
      formatValue: "Présentiel · Distanciel · Blended",
      durationLabel: "Durée",
      audienceLabel: "Public",
      ctaLabel: "Demander le programme",
      tracks: [
        {
          id: "iac",
          name: "Infrastructure as Code",
          tagline: "Industrialisez vos déploiements",
          duration: "3 à 5 jours",
          audience: "Ingénieurs Ops, DevOps, Architectes",
          modules: [
            "Fondamentaux IaC & GitOps",
            "Terraform : providers, modules, state, workspaces",
            "Ansible : playbooks, rôles, inventaires dynamiques",
            "Pulumi & Packer (initiation)",
            "Bonnes pratiques de tests & CI/CD",
          ],
        },
        {
          id: "sysadmin",
          name: "Administration Système",
          tagline: "Maîtrisez Linux et les services critiques",
          duration: "5 jours",
          audience: "Administrateurs systèmes, techniciens IT",
          modules: [
            "Linux avancé (Debian / RHEL)",
            "Réseau, DNS, DHCP, pare-feu (nftables)",
            "Services : Nginx, Apache, PostgreSQL, MySQL",
            "Sauvegarde, supervision, automatisation Bash",
            "Hardening sécurité & conformité",
          ],
        },
        {
          id: "cloud",
          name: "Cloud Computing",
          tagline: "Conception & exploitation cloud-native",
          duration: "4 à 6 jours",
          audience: "Architectes, DevOps, DSI, équipes IT",
          modules: [
            "Architectures cloud (public, privé, hybride)",
            "AWS / Azure / GCP : panorama et services clés",
            "Cloud privé On-Premise (Proxmox, OpenStack)",
            "Conteneurs & orchestration (Docker, Kubernetes)",
            "FinOps : maîtrise des coûts cloud",
          ],
        },
      ],
    },
    offers: {
      overline: "NOS OFFRES",
      title: "Trois niveaux d'accompagnement.",
      subtitle:
        "Du delivery clé-en-main à l'autonomie complète, choisissez le modèle qui vous correspond.",
      recommended: "Recommandé",
      tiers: {
        non: {
          name: "Self-Managed",
          tagline: "Conception & déploiement clé en main",
          features: [
            "Étude des besoins",
            "Architecture cible",
            "Déploiement de l'infrastructure",
            "Documentation complète",
            "Transfert au service IT client",
          ],
          cta: "En savoir plus",
        },
        hybride: {
          name: "Co-Managed",
          tagline: "Collaboration avec votre équipe IT",
          features: [
            "Mise en place de l'infrastructure",
            "Transfert de compétences",
            "Accompagnement des équipes internes",
            "Support & expertise à la demande",
            "Autonomie progressive",
          ],
          cta: "Discuter de ce modèle",
        },
        full: {
          name: "Fully Managed",
          tagline: "Vous vous concentrez sur votre métier",
          features: [
            "Administration systèmes & réseaux",
            "Supervision & maintenance 24/7",
            "Sécurité & conformité",
            "Déploiement & suivi projets",
            "Support technique dédié",
          ],
          cta: "Demander un devis",
        },
      },
    },
    tools: {
      overline: "COLLABORATION & DOCUMENTAIRE",
      title: "Des outils collaboratifs souverains et sécurisés.",
      subtitle:
        "Nous déployons et intégrons des solutions open source robustes pour la collaboration et la gestion documentaire.",
      items: [
        {
          name: "Nextcloud",
          desc: "Plateforme collaborative souveraine : fichiers, calendrier, contacts, workflows.",
        },
        {
          name: "Collabora Office",
          desc: "Suite bureautique en ligne intégrée — édition collaborative en temps réel.",
        },
        {
          name: "Nextcloud Talk",
          desc: "Visioconférence et messagerie chiffrées de bout en bout, hébergées chez vous.",
        },
        {
          name: "Gestion documentaire",
          desc: "GED, indexation, versioning, signature, recherche full-text.",
        },
        {
          name: "Partage sécurisé",
          desc: "Partage de fichiers chiffré, contrôle d'accès, conformité RGPD.",
        },
        {
          name: "Communication d'entreprise",
          desc: "Email, calendriers partagés, intégrations Active Directory / LDAP.",
        },
      ],
    },
    about: {
      overline: "À PROPOS DE SMAKTECH",
      title: "Notre mission",
      mission:
        "SMAKTECH accompagne les entreprises dans la conception, le déploiement et l'exploitation de leurs infrastructures informatiques. Nous bâtissons des plateformes cloud robustes, sécurisées et adaptées à votre activité.",
      expertiseTitle: "Nos domaines d'expertise",
      expertise: [
        "Conseil IT",
        "Architecture Cloud",
        "Cloud privé (On-Premise)",
        "Cloud public & hybride",
        "Supervision & monitoring",
        "Exploitation d'infrastructures",
        "DevOps",
        "Sécurité",
        "Outils collaboratifs",
        "Infrastructure as Code",
        "Orchestration de conteneurs",
      ],
      iacTitle: "Infrastructure as Code",
      iacDesc:
        "Industrialisez vos déploiements et garantissez la reproductibilité de vos environnements avec des pratiques IaC modernes.",
      iacTools: ["Terraform", "Ansible", "Pulumi", "Packer", "Vagrant", "CloudFormation"],
      orchestrationTitle: "Orchestration & Conteneurs",
      orchestrationDesc:
        "Containerisez, orchestrez et faites passer vos applications à l'échelle avec les standards du marché.",
      orchestrationTools: ["Docker", "Docker Compose", "Podman", "Kubernetes", "Helm", "K3s", "Rancher", "OpenShift"],
      valuesTitle: "Notre approche",
      values: [
        {
          title: "Proximité",
          desc: "Une équipe accessible, qui comprend votre métier et vos contraintes.",
        },
        {
          title: "Expertise",
          desc: "Des architectes et ingénieurs expérimentés sur les technologies cloud modernes.",
        },
        {
          title: "Pragmatisme",
          desc: "Des solutions adaptées à votre maturité, pas de sur-ingénierie.",
        },
        {
          title: "Souveraineté",
          desc: "Des choix technologiques respectueux de vos données et de votre indépendance.",
        },
      ],
    },
    contact: {
      overline: "PRENONS CONTACT",
      title: "Parlons de votre projet.",
      subtitle:
        "Une question, un projet d'infrastructure ou un audit cloud ? Écrivez-nous, nous revenons vers vous rapidement.",
      form: {
        name: "Nom complet",
        email: "Email professionnel",
        company: "Société",
        phone: "Téléphone",
        subject: "Sujet",
        message: "Votre message",
        submit: "Envoyer le message",
        sending: "Envoi en cours…",
        successTitle: "Message envoyé",
        successDesc: "Merci, nous revenons vers vous très vite.",
        errorTitle: "Erreur",
        errorDesc: "Impossible d'envoyer votre message. Réessayez ou écrivez directement à contact@smaktech.fr.",
      },
      info: {
        title: "Coordonnées",
        emailLabel: "Email",
        emailValue: "contact@smaktech.fr",
        hoursLabel: "Disponibilité",
        hoursValue: "Lun – Ven, 9h – 18h (CET)",
        scopeLabel: "Zone d'intervention",
        scopeValue: "France & International",
      },
    },
    footer: {
      tagline: "Cloud Computing • Infrastructures IT • DevOps",
      rights: "Tous droits réservés.",
      nav: "Navigation",
      services: "Services",
      legal: "Mentions légales",
      built: "Conçu pour bâtir des infrastructures fiables.",
    },
    common: {
      learnMore: "En savoir plus",
      back: "Retour",
      year: new Date().getFullYear(),
    },
  },
  en: {
    nav: {
      home: "Home",
      services: "Services",
      offers: "Offers",
      tools: "Collaboration tools",
      about: "About",
      contact: "Contact",
      cta: "Get in touch",
    },
    hero: {
      overline: "CLOUD COMPUTING / INFRASTRUCTURE / DEVOPS",
      title1: "Expertise in",
      titleAccent: "Cloud Computing",
      title2: "& IT Infrastructure",
      subtitle:
        "SMAKTECH helps companies design, deploy and operate their IT infrastructure — from advisory to production.",
      ctaPrimary: "Start a project",
      ctaSecondary: "Explore our services",
      stat1: "Advisory",
      stat1Label: "Architecture & Cloud Migration",
      stat2: "24/7",
      stat2Label: "Supervision & Monitoring",
      stat3: "On-Premise",
      stat3Label: "Private & Hybrid Cloud",
    },
    services: {
      overline: "OUR SERVICES",
      title: "End-to-end expertise, from advisory to operations.",
      subtitle: "We cover your entire IT infrastructure value chain.",
      items: {
        consulting: {
          title: "Cloud advisory & support",
          desc: "Right cloud solution selection, architecture design, cloud migration, cost and performance optimization.",
          bullets: [
            "Cloud solution selection",
            "Architecture & design",
            "Cloud migration",
            "On-Premise private cloud",
            "Cost & performance optimization",
            "Tech team enablement",
          ],
        },
        supervision: {
          title: "Supervision & operations",
          desc: "Keeping your critical services up and running, 24/7.",
          bullets: [
            "Infrastructure supervision",
            "Systems & applications monitoring",
            "Proactive incident management",
            "Operational service continuity",
          ],
        },
        infra: {
          title: "IT infrastructure management",
          desc: "Three engagement models — Self-Managed, Co-Managed and Fully Managed — to match your organization.",
          bullets: [
            "Systems & networks administration",
            "Security & compliance",
            "Deployment & project tracking",
            "Technical support",
          ],
        },
        tools: {
          title: "Collaboration tools",
          desc: "Nextcloud, Collabora Office, Nextcloud Talk, document management, secure file sharing.",
          bullets: [
            "Nextcloud",
            "Collabora Office",
            "Nextcloud Talk",
            "DMS & secure sharing",
          ],
        },
      },
    },
    trainings: {
      overline: "TRAININGS",
      title: "Upskill your team with our trainings.",
      subtitle:
        "We train your teams on modern cloud practices, automation and system administration — on-site, remote or blended learning.",
      formatLabel: "Format",
      formatValue: "On-site · Remote · Blended",
      durationLabel: "Duration",
      audienceLabel: "Audience",
      ctaLabel: "Request the syllabus",
      tracks: [
        {
          id: "iac",
          name: "Infrastructure as Code",
          tagline: "Industrialize your deployments",
          duration: "3 to 5 days",
          audience: "Ops, DevOps, Architects",
          modules: [
            "IaC & GitOps fundamentals",
            "Terraform: providers, modules, state, workspaces",
            "Ansible: playbooks, roles, dynamic inventories",
            "Pulumi & Packer (intro)",
            "Testing & CI/CD best practices",
          ],
        },
        {
          id: "sysadmin",
          name: "System Administration",
          tagline: "Master Linux and critical services",
          duration: "5 days",
          audience: "Sysadmins, IT technicians",
          modules: [
            "Advanced Linux (Debian / RHEL)",
            "Networking, DNS, DHCP, firewall (nftables)",
            "Services: Nginx, Apache, PostgreSQL, MySQL",
            "Backup, monitoring, Bash automation",
            "Security hardening & compliance",
          ],
        },
        {
          id: "cloud",
          name: "Cloud Computing",
          tagline: "Cloud-native design & operations",
          duration: "4 to 6 days",
          audience: "Architects, DevOps, CIO, IT teams",
          modules: [
            "Cloud architectures (public, private, hybrid)",
            "AWS / Azure / GCP: overview & key services",
            "Private on-prem cloud (Proxmox, OpenStack)",
            "Containers & orchestration (Docker, Kubernetes)",
            "FinOps: cloud cost mastery",
          ],
        },
      ],
    },
    offers: {
      overline: "OUR OFFERS",
      title: "Three engagement models.",
      subtitle:
        "From turnkey delivery to full autonomy, pick what fits you.",
      recommended: "Recommended",
      tiers: {
        non: {
          name: "Self-Managed",
          tagline: "Turnkey design & deployment",
          features: [
            "Requirements study",
            "Target architecture",
            "Infrastructure deployment",
            "Complete documentation",
            "Handover to client IT team",
          ],
          cta: "Learn more",
        },
        hybride: {
          name: "Co-Managed",
          tagline: "Co-build with your IT team",
          features: [
            "Infrastructure setup",
            "Skills transfer",
            "Internal team enablement",
            "Expertise on demand",
            "Progressive autonomy",
          ],
          cta: "Discuss this model",
        },
        full: {
          name: "Fully Managed",
          tagline: "Focus on your business",
          features: [
            "Systems & networks admin",
            "24/7 supervision & maintenance",
            "Security & compliance",
            "Deployment & project tracking",
            "Dedicated support",
          ],
          cta: "Request a quote",
        },
      },
    },
    tools: {
      overline: "COLLABORATION & DOCUMENTS",
      title: "Sovereign, secure collaboration tools.",
      subtitle:
        "We deploy and integrate robust open source solutions for collaboration and document management.",
      items: [
        {
          name: "Nextcloud",
          desc: "Sovereign collaboration platform: files, calendar, contacts, workflows.",
        },
        {
          name: "Collabora Office",
          desc: "Integrated online office suite — real-time co-editing.",
        },
        {
          name: "Nextcloud Talk",
          desc: "End-to-end encrypted video and chat, self-hosted.",
        },
        {
          name: "Document Management",
          desc: "DMS, indexing, versioning, signature, full-text search.",
        },
        {
          name: "Secure file sharing",
          desc: "Encrypted file sharing, access control, GDPR compliance.",
        },
        {
          name: "Corporate communication",
          desc: "Email, shared calendars, Active Directory / LDAP integration.",
        },
      ],
    },
    about: {
      overline: "ABOUT SMAKTECH",
      title: "Our mission",
      mission:
        "SMAKTECH helps companies design, deploy and operate their IT infrastructure. We build robust, secure cloud platforms tailored to your business.",
      expertiseTitle: "Areas of expertise",
      expertise: [
        "IT advisory",
        "Cloud architecture",
        "Private cloud (On-Premise)",
        "Public & hybrid cloud",
        "Supervision & monitoring",
        "Infrastructure operations",
        "DevOps",
        "Security",
        "Collaboration tools",
        "Infrastructure as Code",
        "Container orchestration",
      ],
      iacTitle: "Infrastructure as Code",
      iacDesc:
        "Industrialize deployments and guarantee reproducibility of your environments with modern IaC practices.",
      iacTools: ["Terraform", "Ansible", "Pulumi", "Packer", "Vagrant", "CloudFormation"],
      orchestrationTitle: "Orchestration & Containers",
      orchestrationDesc:
        "Containerize, orchestrate and scale your applications using industry-standard tools.",
      orchestrationTools: ["Docker", "Docker Compose", "Podman", "Kubernetes", "Helm", "K3s", "Rancher", "OpenShift"],
      valuesTitle: "Our approach",
      values: [
        {
          title: "Closeness",
          desc: "An accessible team that understands your business and constraints.",
        },
        {
          title: "Expertise",
          desc: "Architects and engineers experienced in modern cloud technologies.",
        },
        {
          title: "Pragmatism",
          desc: "Solutions matching your maturity — no over-engineering.",
        },
        {
          title: "Sovereignty",
          desc: "Technology choices that respect your data and independence.",
        },
      ],
    },
    contact: {
      overline: "GET IN TOUCH",
      title: "Let's discuss your project.",
      subtitle:
        "A question, an infrastructure project or a cloud audit? Drop us a line — we reply fast.",
      form: {
        name: "Full name",
        email: "Business email",
        company: "Company",
        phone: "Phone",
        subject: "Subject",
        message: "Your message",
        submit: "Send message",
        sending: "Sending…",
        successTitle: "Message sent",
        successDesc: "Thanks, we'll get back to you very soon.",
        errorTitle: "Error",
        errorDesc: "Could not send your message. Try again or email contact@smaktech.fr directly.",
      },
      info: {
        title: "Contact info",
        emailLabel: "Email",
        emailValue: "contact@smaktech.fr",
        hoursLabel: "Availability",
        hoursValue: "Mon – Fri, 9am – 6pm (CET)",
        scopeLabel: "Coverage",
        scopeValue: "France & International",
      },
    },
    footer: {
      tagline: "Cloud Computing • IT Infrastructure • DevOps",
      rights: "All rights reserved.",
      nav: "Navigation",
      services: "Services",
      legal: "Legal",
      built: "Built to deliver reliable infrastructure.",
    },
    common: {
      learnMore: "Learn more",
      back: "Back",
      year: new Date().getFullYear(),
    },
  },
};
